import { FileText } from "lucide-react";
import PaginaFiscal from "../_components/pagina-fiscal";
import TabelaDocumentos from "./_components/tabela-documentos";
import { useAcoesFiscais, useConsultaFiscal, usePaginacao } from "../hooks";
import {
	baixarXml,
	cancelarNota,
	consultarNota,
	fonteDocumentos,
	imprimirNota,
	listarDocumentos,
} from "../api/documentos";

const CAMPOS_FILTRO = ["modelo", "status", "venda", "cpfCnpj", "cliente"];

export default function DocumentosFiscais() {
	const consulta = useConsultaFiscal(listarDocumentos, "filtroDocumentosFiscais");
	const paginacao = usePaginacao(consulta.itens);
	const acoes = useAcoesFiscais(
		{ imprimir: imprimirNota, baixarXml, consultar: consultarNota, cancelar: cancelarNota },
		consulta.recarregar
	);

	return (
		<PaginaFiscal
			icone={FileText}
			titulo="Documentos Fiscais"
			subtitulo="NF-e e NFC-e com situação fiscal concluída"
			consulta={consulta}
			camposFiltro={CAMPOS_FILTRO}
			acoes={acoes}
			fonte={fonteDocumentos}
		>
			<TabelaDocumentos
				documentos={paginacao.itensPagina}
				total={consulta.itens.length}
				pagina={paginacao.pagina}
				totalPaginas={paginacao.totalPaginas}
				onPagina={paginacao.setPagina}
				carregando={consulta.carregando}
				onAcao={acoes.executar}
				jaBuscou={!!consulta.filtrosAplicados}
			/>
		</PaginaFiscal>
	);
}
